import { Switch } from 'react-router-dom';

import Route from './Route';

import { useAuth } from '../hooks/auth';

import SignIn from '../pages/SignIn';
import SignUp from '../pages/SignUp';
import Dashboard from '../pages/Dashboard';
import Campanha from '../pages/Campanha';
import Vendas from '../pages/Vendas';
import Entregas from '../pages/Entregas';
import Horarios from '../pages/Horarios';
import Cupom from '../pages/Cupom';
import AreaEntrega from '../pages/AreaEntrega';
import Perfil from '../pages/Perfil';

import Produtos from '../pages/Produtos';
import Producao from '../pages/Producao';
import Fichas from '../pages/Fichas';
import Titulo from '../pages/Titulo';
import Lancamento from '../pages/Lancamento';
import Privacy from '../pages/Privacy';
import InformationSecurityPolicy from '../pages/InformationSecurityPolicy';
import Cliente from '../pages/Clientes';
import DeleteAccountLogin from '../pages/DeleteAccountLogin';
import DeleteAccount from '../pages/DeleteAccount';
import Contas from '../pages/Contas';
import Classificacao from '../pages/Classificacao';
import Pix from '../pages/Pix';

const Routes: React.FC = () => {
	const { user } = useAuth();

	return (
		<Switch>
			<Route path="/login" exact component={SignIn} />
			<Route path="/signup" exact component={SignUp} />
			<Route path="/privacy" exact component={Privacy} isPrivate={!!user ? true : false} />
			<Route path="/politica-de-seguranca" exact component={InformationSecurityPolicy} />

			<Route path="/pix/:company/:bank/:txid" exact component={Pix} isPrivate={!!user ? true : false} />

			<Route path="/dashboard" exact component={Dashboard} isPrivate />

			<Route path="/titulos" exact component={Titulo} isPrivate />
			<Route path="/lancamentos" exact component={Lancamento} isPrivate />

			<Route path="/producao" exact component={Producao} isPrivate />
			<Route path="/fichas" exact component={Fichas} isPrivate />

			<Route path="/vendas" exact component={Vendas} isPrivate />

			<Route path="/produtos" exact component={Produtos} isPrivate />

			<Route path="/entregas" exact component={Entregas} isPrivate />
			<Route path="/areaentrega" exact component={AreaEntrega} isPrivate />

			<Route path="/campanha" exact component={Campanha} isPrivate />
			<Route path="/cupom" exact component={Cupom} isPrivate />

			<Route path="/horarios" exact component={Horarios} isPrivate />
			<Route path="/perfil" exact component={Perfil} isPrivate />

			<Route path="/clientes" exact component={Cliente} isPrivate />

			<Route path="/contas" exact component={Contas} isPrivate />

			<Route path="/" exact component={DeleteAccountLogin} />
			<Route path="/accountdelete" exact component={DeleteAccount} isPrivate />

			<Route path="/cassificacao" exact component={Classificacao} isPrivate />
		</Switch>
	)
};

export default Routes;
